import type { ILeadsFilterOptionsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-options";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const BASE_DESCRIPTION_PATH = "/sales-api/advanced-search/description";

const createLeadsSearchFiltersApiService = (fetchService: IFetchService) => {
    return {
        fetchDescription(options?: Readonly<GetRequestOptions>): Promise<ILeadsFilterOptionsDto> {
            return fetchService.get(BASE_DESCRIPTION_PATH, undefined, options);
        },
    };
};

export default createLeadsSearchFiltersApiService;
